
import {map, filter} from 'rxjs/operators';
import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import {
  each as _each,
  last as _last,
  trim as _trim,
  filter as _filter
} from 'lodash';
import { isSLFeatureEnabled } from '../shares-ledger';

@Component({
  selector: 't-breadcrumb',
  templateUrl: './breadcrumb.component.html',
})
export class BreadcrumbComponent implements OnInit {

  breadcrumbs: any[] = [];
  currentUrl: string;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
  ) { }

  ngOnInit() {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      map((event: NavigationEnd) => {
        this.currentUrl = _trim(event.urlAfterRedirects, '/');

        return event;
      }),
      map((event => this.activatedRoute)),
      map((route) => {
        let routes = [];

        while (route.firstChild) {
          route = route.firstChild;
          routes.push(route);
        }

        return routes;
      }),)
      .subscribe((routes) => {
        let urlSegments = this.currentUrl.split('/');

        this.breadcrumbs = [];

        routes.forEach((route, index) => {

          let breadcrumb = {
            index: index,
            title: route.snapshot.data.title,
            url: '/' + urlSegments.slice(0, index + 1).join('/'),
            hidden: route.routeConfig.path === ''
          };

          this.breadcrumbs.push(breadcrumb);

          route.data.subscribe((data) => {

            if (data) {
              let operation = data.operation;
              let dossier = data.dossier;
              let record = data.record;
              let execution = data.execution;
              let entity = data.entity;

              // Rename route titles
              _each(this.breadcrumbs, breadcrumb => {

                // Operation resolved
                if (breadcrumb.title === 'OPERATION_NAME' && operation) {
                  breadcrumb.title = operation.name;
                }
                // Revision resolved
                else if (breadcrumb.title === 'REVISION_NAME' && operation && operation.revision) {
                  breadcrumb.title = operation.revision.fullname;
                }
                // Dossier resolved
                else if (breadcrumb.title === 'DOSSIER_NAME' && dossier) {
                  breadcrumb.title = dossier.name;
                }
                // Record resolved
                else if (breadcrumb.title === 'RECORD_NAME' && record) {
                  breadcrumb.title = record.name;
                }
                // Entity resolved (Organigramme)
                else if ((breadcrumb.title === 'DOSSIER_NAME' || breadcrumb.title === 'RECORD_NAME') && entity) {
                  breadcrumb.title = entity.name;
                }
                // Execution resolved
                else if (breadcrumb.title === 'DOSSIER_NAME' && execution && execution.dossiers) {
                  breadcrumb.title = execution.dossiers[0].dossier.name;
                }
                else if (breadcrumb.title === 'OPERATION_NAME' && execution && execution.operation) {
                  breadcrumb.title = execution.operation.name;
                }
                else if (breadcrumb.title === 'REVISION_NAME' && execution && execution.revision) {
                  breadcrumb.title = execution.revision.fullname;
                }
                // SL Integration
                else if (breadcrumb.title === 'SL_ENTITY_NAME' && isSLFeatureEnabled()  && entity) {
                  breadcrumb.title = data.entity.name;
                }
                else if (breadcrumb.title === 'CL_ACCOUNT_NAME' && isSLFeatureEnabled()  && data.account) {
                  breadcrumb.title = data.account.name;
                }
                else if (breadcrumb.title === 'CL_USER_NAME' && isSLFeatureEnabled()  && data.user) {
                  breadcrumb.title = data.user.fullname;
                }
                // DL Integration
                else if (breadcrumb.title === 'DL_ROOT_CERTIFICATE_NAME' && isSLFeatureEnabled()  && data.rootCertificate) {
                  breadcrumb.title = data.rootCertificate.name;
                }
                else if (breadcrumb.title === 'DL_COMPANY_NAME' && isSLFeatureEnabled()  && data.company) {
                  breadcrumb.title = data.company.fullname;
                }
                else if (breadcrumb.title === 'DL_LEDGER_NAME' && isSLFeatureEnabled()  && data.company) {
                  breadcrumb.title = data.company.ledgers[0].name;
                }
              });
            }
          });

        });

        // Filter out hidden breadcrumbs
        this.breadcrumbs = _filter(this.breadcrumbs, (breadcrumb) => !breadcrumb.hidden);

        // Make last breadcrumb hidden
        _last(this.breadcrumbs).hidden = true;
      });
  }
}